import { listenToPicturesByIds } from './pictures';
import { listenToPresentationsByIds } from './presentations';

export const requestSetPictures = () => {
  return (dispatch, getState) => {
    const stateSets = getState().sets;
    const setPicturesIds = stateSets[getState().ui.set].photo;
    dispatch(listenToPicturesByIds(setPicturesIds));
  }
};

export const requestSetDescrPdf = () => {
  return (dispatch, getState) => {
    dispatch(listenToPresentationsByIds([].concat(getState().ui.set)));
  }
};



// WEBPACK FOOTER //
// ./src/actions/sets.js